<div class="replace-vehicle main">
  <div class="row pad-top-40">
    <div class="column twelve lg-eight lg-push-two md-eight md-push-two">
      <h2 class="bold-header">
        {{
          (isPartner$ | async)
            ? 'Are you replacing a vehicle?'
            : 'Are you adding or replacing a vehicle?'
        }}
      </h2>

      <form [formGroup]="riskSelectionForm">
        <!-- The data has not come back yet -->
        @if (loading$ | async) {
          <ds-localized-spinner
            class="block pad-bottom-20"
            [dataLoading]="loading$ | async"
            [loadingMessage]="'Looking for vehicles...'"
          ></ds-localized-spinner>
        }

        @if (!(loading$ | async)) {
          <div>
            <div class="row pad-bottom-10">
              <fieldset>
                <ds-risk-list
                  [risks]="vehicles"
                  [otherLabel]="addVehicleLabel"
                  (riskChange)="changeRisk($event)"
                  [vehicleLabel]="(isPartner$ | async) === false ? replaceVehicleLabel : null"
                  [showPolicyNumber]="isPartner$ | async"
                  [showIcon]="isPartner$ | async"
                >
                </ds-risk-list>
              </fieldset>
            </div>
            @if ((isPartner$ | async) === false) {
              <div class="column twelve">
                {{ gracePeriodContent }}
                <a (click)="toggleGracePeriod()">View details.</a>
              </div>
            }
          </div>
        }
        <call-to-action
          [displayBackButton]="true"
          [tertiaryButtonName]="'Cancel'"
          [disabled]="!riskSelectionForm.valid || (loading$ | async) || !(authorized$ | async)"
          [primaryButtonName]="(isPartner$ | async) ? 'Next Step' : 'Continue'"
          (primaryEvent)="riskSelectionSubmit()"
          (tertiaryEvent)="cancel()"
          (backEvent)="back()"
        ></call-to-action>
      </form>
    </div>
  </div>
</div>

<ds-grace-period
  [isAdvancedCustomer]="hasAdvanceAutoPolicy$ | async"
  [visible]="displayPolicyGracePeriod"
  [isPartner]="isPartner$ | async"
  (visibleChange)="onVisibleChange($event)"
></ds-grace-period>
